(function(){
  var images=[
    'https://geekfan.mx/cdn/shop/t/4/assets/slide-gaming.jpg?v=1777670861',
    'https://geekfan.mx/cdn/shop/t/4/assets/slide-3dprint.jpg?v=1777670863',
    'https://geekfan.mx/cdn/shop/t/4/assets/slide-mobility.jpg?v=1777670865'
  ];
  var idx=Math.floor(Math.random()*images.length);
  function rotate(){
    var el=document.getElementById('Banner-template--18494973935766__image_banner');
    if(!el) return;
    el.style.transition='background 1.2s ease-in-out';
    el.style.backgroundImage='url('+images[idx]+')';
    el.style.backgroundSize='cover';
    el.style.backgroundPosition='center';
    el.style.backgroundRepeat='no-repeat';
    var imgs=el.querySelectorAll('.banner__media img,.banner__media-image');
    imgs.forEach(function(img){img.style.opacity='0';});
    idx=(idx+1)%images.length;
  }
  if(document.readyState==='complete') rotate();
  else window.addEventListener('load', rotate);
  setInterval(rotate, 8000);
})();